import React, { Fragment } from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import withAuth from '../../hocs/withAuth';
import { COLORS } from '../../styles/colors'
import AddIcon from '@material-ui/icons/Add';
import { Link } from "react-router-dom";
import StartCalendar from "./StartCalendar";
import EndCalendar from "./EndCalendar";
import TreeView from "./TreeView";
import ActionForm from './ActionForm';
import ActionListing from './../assignments/ActionsListing';
import moment from 'moment';
import { AlertJsMessage, ConfirmJsMessage } from './../../helpers.js';

class PreviewActionPlan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: props.isOpenAddModal,
            formData: {
                title: ''
            },
            selectedTab: 'committedAction',
            actions: [],
        }
        this.prepareData = [];
    }

    
    componentDidMount() {
        this.fetchActionList([this.props.range._id]);
    }

  
    fetchActionList = (rangeIds) => {
        this.setState({
            actions: []
        })
        this.props.fetchActions(rangeIds)
        .then((res) => {
            const actions = res.data && res.data.data.map((data) => {
                return {
                    path: data.title,
                    type: "tree",
                    _id: data._id,
                    isCompleted: data.isCompleted,
                    tree: data.subActions.map((data) => {
                        return {
                            path: data.title,
                            _id: data._id,
                            isCompleted: data.isCompleted
                        }
                    })
                }
            })
            this.setState({
                actions: actions
            })
        })
    }

    onClose = () => this.setState({ show: false }, () => this.props.hideActionModal());

    renderDate = (date) => {
        return moment(date).utc(0, true).format('MM/DD/YYYY');
    }

    render() {
        const { show, actions } = this.state;
        const filterActions = actions;
        const { range } = this.props;
        return (
            <Modal
                className="modal show"
                open={show}
                onClose={this.onClose}
            >
                <div className="modalBody modal-content" style={{ width: 500, minHeight: 500 }}>
                        <Fragment>
                            <ModalHeading
                                text={ `Preview - ${this.renderDate(range.startDate) } - ${ this.renderDate(range.endDate)}` }
                                closeModal={this.onClose}
                            />
                            <div className="modalContent">
                                    <Fragment>
                                        {filterActions.map((item, index) => {
                                            return (
                                            <Fragment>
                                                <TreeView 
                                                    onEditAction = {this.onEditAction} 
                                                    key={index}
                                                    isPreview = {true}
                                                    item = {item}>
                                                </TreeView>
                                            </Fragment>
                                            )
                                        })}
                                    </Fragment>
                                
                            </div>
                        </Fragment>
                </div>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(PreviewActionPlan));



// WEBPACK FOOTER //
// ./src/components/assignments/PreviewActionPlan.js